export default __webpack_public_path__ + "static/media/hht2_ep04_timeline_q03_b.68917030.png";